import JSRouter from "adminPage/JSRouter";
import FormValidator from "base/FormValidator";
import Message from "base/Message";
import Ajax from "base/Ajax";

JSRouter.register('sk8House', new RegExp('^/locations/([0-9a-f]+)/?'), (url_args) => {

    let $form = $('.js-location-form');

    FormValidator.attach($form).on("submit", ($form) => {
        let $btn = $form.find("button[type='submit']");
        if ($btn.is(".admin-btn--loading")) return;
        $btn.addClass("admin-btn--loading");

        Ajax.post("sk8House", "locations/" + url_args[0], $form.serializeJSON()).then((location) => {
            new Message('Event updated successfully', '', Message.SUCCESS);
            $btn.removeClass("admin-btn--loading");
        }).catch((e) => {
            $btn.removeClass("admin-btn--loading");
            new Message(e.message, "Couldn't update this event");
        })
    });

});